import { render } from "./TransactionTable.vue?vue&type=template&id=2aa8106d&scoped=true"
import script from "./TransactionTable.vue?vue&type=script&lang=js"
export * from "./TransactionTable.vue?vue&type=script&lang=js"

import "./TransactionTable.vue?vue&type=style&index=0&id=2aa8106d&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa8106d"]])

export default __exports__